/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const publishDataSchema = z.object({ published: z.number() });

export const publishCollectionChallengesResponseSchema = createApiResponseSchema(
  publishDataSchema,
) as z.ZodSchema<IAPI<{ published: number }>>;

export type IPublishCollectionChallengesResponse = IAPI<{ published: number }>;
